import React from 'react';
import { FormControlLabel, Grid, Switch } from '@mui/material';
import InputConfig from '../../../../../../Components/InputConfig';

const FTGUCModel = ({ engineModelConfig, index, handleConfigsChange,updateSwitchInputField, keyData, enabled }) => {
	/**
	 * Handles updating step values (increment/decrement) for floor adjustment.
	 * Prevents negative values.
	 *
	 * @param {string} stepType - Either "increment" or "decrement"
	 * @param {string|number} val - Input value from user
	 * @returns {void}
	 */
	const createStepHandler = (stepType, val) => {
		const newValue = parseInt(val, 10);

		handleConfigsChange(index, 'floorAdjustSteps', {
			...engineModelConfig.floorAdjustSteps,
			[stepType]: newValue
		});
	};

	/**
	 * Handles updates to fill and unfill threshold values.
	 * Prevents negative values.
	 *
	 * @param {string} field - Field name to update ("fillThreshold" or "unfillThreshold")
	 * @param {string|number} val - Input value from user
	 * @returns {void}
	 */
	const handleFillAndUnfillChange = (field, val) => {
		const newValue = parseFloat(val);

		handleConfigsChange(index, field, newValue);
	};

	return (
		<>
			<Grid item xs={12} sm={6}>
				<InputConfig
					keyData={`${keyData}.configs.${index}.fillThreshold`}
					label="Fill Threshold"
					inputType="number"
					isObjectEditor={false}
					labelStyles={{ fontSize: '1.5rem' }}
					containerStyles={{ marginTop: '1.3rem', marginLeft: '0.4rem' }}
					directValue={engineModelConfig?.fillThreshold}
					updateDirectValue={(val) => handleFillAndUnfillChange('fillThreshold', val)}
					editable={enabled && engineModelConfig.incDecEnabled}
				/>
			</Grid>

			<Grid item xs={12} sm={6}>
				<InputConfig
					keyData={`${keyData}.configs.${index}.unfillThreshold`}
					label="Unfill Threshold"
					inputType="number"
					isObjectEditor={false}
					labelStyles={{ fontSize: '1.5rem' }}
					containerStyles={{ marginTop: '1.3rem', marginLeft: '0.4rem' }}
					directValue={engineModelConfig?.unfillThreshold}
					updateDirectValue={(val) => handleFillAndUnfillChange('unfillThreshold', val)}
					editable={enabled && engineModelConfig.incDecEnabled}
				/>
			</Grid>

			<Grid item xs={12} sm={6}>
				<InputConfig
					keyData={`${keyData}.configs.${index}.decrement`}
					label="Decrement Steps"
					inputType="number"
					isObjectEditor={false}
					labelStyles={{ fontSize: '1.5rem' }}
					containerStyles={{ marginTop: '1.3rem', marginLeft: '0.4rem' }}
					directValue={engineModelConfig.floorAdjustSteps?.decrement || 0}
					updateDirectValue={(val) => createStepHandler('decrement', val)}
					editable={enabled && engineModelConfig.incDecEnabled}
				/>
			</Grid>

			<Grid item xs={12} sm={6}>
				<InputConfig
					keyData={`${keyData}.configs.${index}.increment`}
					label="Increment Steps"
					inputType="number"
					isObjectEditor={false}
					labelStyles={{ fontSize: '1.5rem' }}
					containerStyles={{ marginTop: '1.3rem', marginLeft: '1rem' }}
					directValue={engineModelConfig.floorAdjustSteps?.increment || 0}
					updateDirectValue={(val) => createStepHandler('increment', val)}
					editable={enabled && engineModelConfig.incDecEnabled}
				/>
			</Grid>

			<Grid item xs={6}>
				<FormControlLabel
					control={
						<Switch
							checked={engineModelConfig.incDecEnabled}
							onChange={(e) => updateSwitchInputField(index, "incDecEnabled", e.target.checked)}
						/>
					}
					label="Enable Increment/Decrement"
					style={{ fontSize: '1.5rem', marginLeft: '0.1rem', fontWeight: 'bold', color: 'grey' }}
				/>
			</Grid>

			<Grid item xs={6}>
				<FormControlLabel
					control={
						<Switch
							checked={!engineModelConfig.floorDecreaserAndLooperEnabled ? false : true}
							onChange={(e) => updateSwitchInputField(index, "floorDecreaserAndLooperEnabled", e.target.checked)}
						/>
					}
					label="Floor Decreaser and Looper"
					style={{ fontSize: '1.5rem', marginLeft: '0.1rem', fontWeight: 'bold', color: 'grey' }}
				/>
			</Grid>


			<Grid item xs={6}>
				<InputConfig
					keyData={`${keyData}.configs.${index}.initialFloorMultiplier`}
					label="Default Floor Multiplier"
					inputType="number"
					isObjectEditor={false}
					labelStyles={{ fontSize: '1.5rem' }}
					containerStyles={{ marginTop: '1rem', marginLeft: '0.4rem' }}
					directValue={engineModelConfig.initialFloorMultiplier?.DEFAULT}
					editable={enabled}
					updateDirectValue={(value) =>
						handleConfigsChange(index, 'initialFloorMultiplier', {
							DEFAULT: value
						})
					}
				/>
			</Grid>
		</>
	);
};

export default FTGUCModel;
